




























































































import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import MoveDesksModal from "@/components/modals/move-desks.vue";
import { Desk, Zone } from "@/swagger/models";
import { deskService } from "@/services/desk";
import { Committable, WrapService } from "@/plugins/committable";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import Card from "@/components/layout/card.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import TabsDesk from "@/views/desk/desk-tabs.vue";
import { zoneService } from "@/services/zone";
import { subject } from "@casl/ability";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "desks",
    components: { TabsDesk, PageHeader, Card, CommitResetBar, MoveDesksModal, Page },
})
export default class DeskView extends Vue {
    committable: Committable<Desk>;
    zones: Zone[] = [];

    nextId: number = null;
    previousId: number = null;

    async created() {
        try {
            this.committable = new Committable<Desk>({
                onCommit: WrapService(deskService, {
                    ignoredFields: ["deletedAt"],
                    createFields: ["name", "zoneId"],
                    patchFields: ["name", "zoneId"],
                    routeIdParam: "deskId",
                    router: this.$router,
                }),
            });

            if (this.$route.params.deskId === "new") {
                this.committable.set(deskService.build());
                // this.selectedZone = this.zones.find((z) => z.id === parseInt(this.$route.query.zone));
            } else {
                const res = await deskService.getNew(parseInt(this.$route.params.deskId));
                this.committable.set(res.data);
                this.previousId = res.previousId;
                this.nextId = res.nextId;
            }

            const zoneRes = await zoneService.findNew({
                params: { office: this.$route.params.officeId },
            });
            this.zones = zoneRes.data;
        } catch (e) {
            console.warn(e);
            await this.$router.back();
        }
    }

    async activateDesk(activate: boolean) {
        const wasDirty = this.committable.dirty.value;
        if (activate) {
            await deskService.activateDesks([parseInt(this.$route.params.deskId)]);
            this.committable.clone.value.deletedAt = null;
        } else {
            await deskService.deactivateDesks([parseInt(this.$route.params.deskId)]);
            this.committable.clone.value.deletedAt = "xxx"; // Value doesn't matter, it's only used for toggling
        }
        this.committable.dirty.value = wasDirty;
    }

    get canEdit() {
        if (this.committable.loading.value) return false;
        // @ts-ignore
        if (this.$route.params.deskId === "new" && this.$can("create", "Desk")) return true;
        // @ts-ignore
        else if (this.$can("update", subject("Desk", this.committable?.original?.value))) return true;
        return false;
    }

    get canActivate() {
        return this.$route.params.deskId !== "new" && this.canEdit;
    }
}
